const $ = jQuery.noConflict();

class Accordions {
	constructor( trigger ) {
		this.trigger = $( trigger );
	}
	init() {
		this.bindEvents();
	}
	bindEvents() {
		this.trigger.on( 'click', this.toggleAccordion );
	}
	toggleAccordion() {
		$('.bellow').removeClass('active');
		$('.bellow__content').stop().slideUp(250);

		$( this ).parents( '.content-links-image__links' ).find( '.content-links-image__link.active:not([data-image-url="' + $( this ).parent().attr( 'data-image-url' ) + '"])' ).removeClass( 'active' ).find( '.bellow__content' ).stop().slideToggle( 250 );
		$( this ).parent().toggleClass( 'active' );
		$( this ).next().stop().slideToggle( 250 );
		if ( $( this ).parent().attr( 'data-image-url' ) ) {
			$( this ).parents( '.row' ).find( '.content-links-image__thumbnail-container img' ).attr( 'src', $( this ).parent().attr( 'data-image-url' ) );
			$( this ).parents( '.row' ).find( '.content-links-image__thumbnail-container img' ).attr( 'srcset', '' );
		}
	}
}

export default new Accordions( '.bellow__title' );
